import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";

const allFields = [
    { value: "CodigoTransacao", label: "Código Transação" },
    { value: "Documento", label: "Documento" },
    { value: "Historico", label: "Histórico" },
    { value: "Valor", label: "Valor" },
    { value: "Taxa", label: "Taxa" },
    { value: "Vencimento", label: "Vencimento" },
    { value: "DataEmissao", label: "Data Emissão" },
    { value: "DataBaixa", label: "Data Baixa" },
    { value: "Status", label: "Status" },
    { value: "FormaPagamentoName", label: "Forma de Pagamento" },
    { value: "CategoriaFinanceiraName", label: "Categoria Financeira" },
    { value: "ContaFinanceiraName", label: "Conta Financeira" },
    { value: "TipoContaPagarName", label: "Tipo de Conta" },
];

interface Props {
    isOpen: boolean;
    toggle: () => void;
    filters: any;
    onExport: (selectedFields: string[]) => void;
}

export const ExportRelatorioModal: React.FC<Props> = ({ isOpen, toggle, filters, onExport }) => {
    const [selected, setSelected] = useState<string[]>([]);

    useEffect(() => {
        if (isOpen) {
            setSelected([]);
        }
    }, [isOpen]);

    const toggleField = (field: string) => {
        setSelected((prev) =>
            prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field]
        );
    };

    const handleExport = () => {
        onExport(selected);
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Selecionar campos do relatório</ModalHeader>
            <ModalBody>
                {allFields.map((field) => (
                    <FormGroup check key={field.value}>
                        <Label check>
                            <Input
                                type="checkbox"
                                checked={selected.includes(field.value)}
                                onChange={() => toggleField(field.value)}
                            />
                            {field.label}
                        </Label>
                    </FormGroup>
                ))}
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleExport} disabled={selected.length === 0}>
                    Exportar PDF
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Modal>
    );
};